import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import View from './View';

const EMPTY_MODAL_STATE = {
  url: '',
  show: false,
  defaultText: '',
  prompt: '',
  isLoading: false,
};

const Investigation = ({ resource, refreshResource }) => {
  const [modalProps, setModalProps] = React.useState(EMPTY_MODAL_STATE);
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Appeal' });

  const onClick = (relationship, prompt) => {
    const linkURL = resource.relationship(relationship)?.link('related').url();
    if (linkURL) {
      const url = new URL(linkURL);
      setModalProps({
        url,
        show: true,
        defaultText: decodeURI(url.searchParams.get('message')),
        prompt,
        isLoading: false,
      });
    } else {
      setModalProps(EMPTY_MODAL_STATE);
    }
  };
  const onSubmit = async (text) => {
    logEvent('Submitted Appeal');
    setModalProps(EMPTY_MODAL_STATE);

    setModalProps({ ...modalProps, isLoading: true });
    try {
      const originalURL = new URL(modalProps.url);
      originalURL.searchParams.set('message', text);
      const newURL = originalURL.toString();
      await fr.http.Put(newURL, resource.export());
      await refreshResource();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setModalProps({ ...modalProps, show: false, isLoading: false });
    }
  };

  const onClickAppeal = resource.relationship('appeal') ? () => {
    onClick('appeal', 'Appeal');
    logEvent('Click Appeal');
  } : null;
  const onClickAccept = resource.relationship('accept') ? () => {
    onClick('accept', 'Accept');
    logEvent('Click Accept');
  } : null;
  const onClickReject = resource.relationship('reject') ? () => {
    onClick('reject', 'Reject');
    logEvent('Click Reject');
  } : null;
  return (
    <View
      resource={resource}
      onClickAppeal={onClickAppeal}
      onClickAccept={onClickAccept}
      onClickReject={onClickReject}
      onClose={() => {
        setModalProps(EMPTY_MODAL_STATE);
        refreshResource();
      }}
      onSubmit={onSubmit}
      modalProps={modalProps}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

Investigation.propTypes = {
  resource: PropTypes.object.isRequired,
  refreshResource: PropTypes.func.isRequired,
};

export default Investigation;
